<template>

    <v-card >
        <v-card-title>{{this.$t('simulacion.modulo.eolica.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
            <v-col cols="12">
                
                <v-container>

                    <!--
                    <v-form v-model="valid" lazy-validation>
                    <v-row>
                        <v-col v-for="(value, key) in datos" :key="key" cols="12" sm="3">

                        <v-text-field v-if="!campos_ocultos.includes(key)"
                            density="compact"  
                            variant="outlined" 
                            :label="formatLabel(key)"
                            v-model.number="datos[key]"
                            :type="getFieldType(key)"                            
                            :hint="getHint(key)"
                            @input="updateValue" 
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    
                    </v-form>
                    

                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexf')"
                            v-model.number="datos['capexf']"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexv')"
                            v-model.number="datos['capexv']"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('opex')"
                            v-model.number="opex"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                    </v-row>
-->

                
            <v-row>
                      <v-col cols="3" sm="3">
                        <v-typography variant="h1">
                          {{ $t('simulacion.modulo.electrolizador.datos_economicos') }}
                        </v-typography>                                              
                      </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="6" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                        v-model="usarCurvasBOP"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                    <v-col cols="6" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                      v-if="!usarCurvasBOP"
                        v-model="usarOpexAnual"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.opex_anual') "
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>
            <v-row v-if="!usarCurvasBOP">
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX 
                        :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.eolica.capex')"
                        v-model:valorVariable="datos.capexv"
                        v-model:valorFijo="datos.capexf"
                        unidad-variable="kEUR/MW"
                        unidad-fijo="kEUR"
                        />
                      </v-col>


                      <v-col cols="3" sm="3" v-if="!usarOpexAnual">
                        <ComponenteEditorCAPEXOPEX 
                        :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.eolica.opex')"
                        v-model:valorVariable="datos.opexv"
                        v-model:valorFijo="datos.opexf"
                        unidad-variable="kEUR/MW año"
                        unidad-fijo="kEUR año"
                        />
                      </v-col>
                      <!--
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX titulo="Capex BOP (EUR/MW eólica):"/>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX titulo="Capex Reemplazo stacks (EUR/MW):"/>
                      </v-col> 
                      --> 
                    </v-row>
                    <v-row>
                    <v-col cols="12" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                        v-model="usarCurvasConexion"
                        :label="usarCurvasConexion ? $t('simulacion.modulo.ejecucion.switch.conexion') : $t('simulacion.modulo.ejecucion.switch.conexion')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>

                  <v-row v-if="usarCurvasConexion">
                    <v-col cols="12" sm="6" md="4">
                      <ComponenteEditorCAPEXOPEX
                      :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.eolica.capexcel')"
                        v-model:valorVariable="datos.capexvcel"
                        v-model:valorFijo="datos.capexfcel"
                        unidad-variable="kEUR/MW"
                        unidad-fijo="kEUR"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <ComponenteEditorCAPEXOPEX
                      :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.eolica.opexcel')"
                        v-model:valorVariable="datos.opexvcel"
                        v-model:valorFijo="datos.opexfcel"
                        unidad-variable="kEUR/MW año"
                        unidad-fijo="kEUR año"
                      />
                    </v-col>
                  </v-row>         
                  </v-container>

                </v-col>
                </v-row>
              
                 <v-row>
                      <v-col cols="12">
                      
                      <div v-if="!usarCurvasBOP && usarOpexAnual">
                        <ComponenteInputMatrizAnual
                          :title="$t('simulacion.modulo.curvas_CAPEXOPEX.opex_anual_title')"
                          :disabled="this.disabled"
                          :modelValue="this.datos.senda_opex"
                          :years="this.years"
                          nombre_tabla="OPEX"
                          :nombres_fila="['Fijo','Variable']"
                          :nombres_tabla="{
                            fijo: $t('simulacion.modulo.curvas_CAPEXOPEX.fijo_units'),
                            variable: $t('simulacion.modulo.curvas_CAPEXOPEX.variable_units'),
                          }"
                          @update:modelValue="datos.senda_opex = $event"
                        />

                       
                      </div>
                       </v-col>
                  </v-row>
                  <ComponenteInputMatrizAnual
                    :title="$t('simulacion.modulo.curvas_CAPEXOPEX.precio_transferencia_interno')"
                    :disabled="this.disabled"
                    :modelValue="sendaPCEOL"
                    :years="this.years"
                    nombre_tabla="Precio transferencia interno eolica"
                    :nombres_fila="['precio']"
                    :nombres_tabla="{
                      'precio': 'EUR/MWh',
                    }"
                    @update:modelValue="actualizarSendaPCEOL"
                  />
        </v-card-text>
    </v-card>



</template>

<script>
import ComponenteEditorCAPEXOPEX from '../components/ComponenteEditorCAPEXOPEX.vue';
import ComponenteInputMatrizAnual from './ComponenteInputMatrizAnual.vue';
export default {
  props: {
    disabled:{
      type:Boolean,
      default:false
    },
    modelValue: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },
      years:{
    type:Array,
    required:true
  },
    usarCapexOpexGeneralEolica: String
  },
  components:{
    ComponenteEditorCAPEXOPEX,
    ComponenteInputMatrizAnual
  },
  
  data() {
    return {
      valid: false,
      datos: { ...this.modelValue,
        capexfcel: this.modelValue?.capexfcel ?? 0,
      capexvcel: this.modelValue?.capexvcel ?? 0,
      opexfcel:  this.modelValue?.opexfcel  ?? 0,
      opexvcel:  this.modelValue?.opexvcel  ?? 0,
        curvas_conexion: {
        capex: this.modelValue?.curvas_conexion?.capex ?? 0,
        opex:  this.modelValue?.curvas_conexion?.opex  ?? 0,
      }, // Inicializa los datos con el valor recibido
      }, 
      labels: {
        pmax: this.$t('simulacion.modulo.eolica.pmax'),
        capexf: this.$t('simulacion.modulo.eolica.capexf'),
        capexv: this.$t('simulacion.modulo.eolica.capexv'),
        opex: this.$t('simulacion.modulo.eolica.opex'),
        degrad: this.$t('simulacion.modulo.eolica.degrad'),
        ppvfija: this.$t('simulacion.modulo.eolica.ppvfija'),
      },
      campos_ocultos: ["ppvfija","pmax","peolfija"],

      rules: {
        required: v => !!v || 'This field is required',
        Negativo: (v) => {
        return v === null || v === undefined || v === '' || v >= 0
          ? true
          : 'El valor no puede ser negativo';
          }
      },
      usarCapexOpexGeneral: this.usarCapexOpexGeneralEolica || 'especifico'
    };
  },


  computed: {
    sendaPCEOL() {
  const years = Array.isArray(this.years) ? this.years.map(Number) : [];
  const base = Array.isArray(this.modelValue?.senda_pceol)
    ? this.modelValue.senda_pceol
    : [];

  return years.map(anio => {
    const existente = base.find(x => Number(x?.anio) === anio);

    return {
      anio,
      precio: Number(existente?.precio ?? 0),
    };
  });
},
    usarOpexAnual: {
  get() {
    return this.datos.opex_anual === 1;
  },
  set(val) {
    this.datos.opex_anual = val ? 1 : 0;

    if (val) {
      const actual = this.datos.senda_opex;
      const years = Array.isArray(this.years) ? this.years.map(Number) : [];

      const esValida =
        Array.isArray(actual) &&
        actual.length > 0 &&
        actual.some(x => years.includes(Number(x?.anio)));

      if (!esValida) {
        this.datos.senda_opex = years.map(anio => ({
          anio,
          fijo: Number(this.datos.opexf ?? 0),
          variable: Number(this.datos.opexv ?? 0),
        }));
      }
    }
  }
},

    opex: {
      get() {        
        const value = this.datos.opex 
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.opex = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    usarCurvasBOP: {
      get() {
        return this.datos.curvas?.capex === 1 && this.datos.curvas?.opex === 1;
      },
      set(val) {
        this.datos.curvas.capex = val ? 1 : 0;
        this.datos.curvas.opex = val ? 1 : 0;
      }
    },
    usarCurvasConexion: {
    get() {
      return this.datos.curvas_conexion?.capex === 1 && this.datos.curvas_conexion?.opex === 1;
    },
    set(v) {
      this.datos.curvas_conexion.capex = v ? 1 : 0;
      this.datos.curvas_conexion.opex  = v ? 1 : 0;
       //  Si apagamos el switch, reseteamos los valores
    if (!v) {
      this.datos.capexfcel = 0
      this.datos.capexvcel = 0
      this.datos.opexfcel  = 0
      this.datos.opexvcel  = 0
    }
    }
    },


  },

  watch: {
    // Vigila los cambios en `datos` y emite el evento cuando cambian
    datos: {
      handler(newDatos) {
        this.$emit('update:modelValue', newDatos);
      },
      deep: true, // Escucha los cambios profundos dentro de `datos`
    },

    '$i18n.locale'() {                
      this.labels.pmax = this.$t('simulacion.modulo.eolica.pmax')
      this.labels.capexf = this.$t('simulacion.modulo.eolica.capexf')
      this.labels.capexv = this.$t('simulacion.modulo.eolica.capexv')
      this.labels.opex = this.$t('simulacion.modulo.eolica.opex')
      this.labels.degrad = this.$t('simulacion.modulo.eolica.degrad')
      this.labels.ppvfija = this.$t('simulacion.modulo.eolica.ppvfija')
    },



  },


  methods: {
actualizarSendaPCEOL(nuevaSenda) {
  this.datos.senda_pceol = nuevaSenda;

  this.$emit('update:modelValue', {
    ...this.modelValue,
    senda_pceol: nuevaSenda,
  });
},
    actualizarDatos(){
        this.datos = {
  ...this.modelValue,
  senda_pceol: this.modelValue?.senda_pceol ?? [],
  senda_opex: Array.isArray(this.modelValue?.senda_opex)
    ? this.modelValue.senda_opex
    : [],
  capexfcel: this.modelValue?.capexfcel ?? 0,
  capexvcel: this.modelValue?.capexvcel ?? 0,
  opexfcel: this.modelValue?.opexfcel ?? 0,
  opexvcel: this.modelValue?.opexvcel ?? 0,
  curvas_conexion: {
    capex: this.modelValue?.curvas_conexion?.capex ?? 0,
    opex: this.modelValue?.curvas_conexion?.opex ?? 0,
  },
}
},

    
    formatLabel(key) {
      let out = key.charAt(0).toUpperCase() + key.slice(1)
      out = this.labels[key]
      return out;
    },
    getFieldType(key) {
      if (key === 'capac' || key === 'capex' || key === 'nfijo') {
        return 'number';
      }
      return 'text';
    },
    getHint(key) {
      if (key === 'capex') {
        return 'In currency';
      }
      return '';
    },
    saveData() {
      console.log('Data saved:', this.datos);
    },
    emitirOpcionGeneral() {
      this.$emit('update:usarCapexOpexGeneralFotovoltaica', this.usarCapexOpexGeneral);
    }
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
</style>
